import { render, staticRenderFns } from "./fetchActivitiesForOverview.vue?vue&type=template&id=51386c60&scoped=true&"
import script from "./fetchActivitiesForOverview.vue?vue&type=script&lang=js&"
export * from "./fetchActivitiesForOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51386c60",
  null
  
)

export default component.exports